import { ComposeStepState, IComposeStep } from ".";
import { is } from "immutable";
import * as React from "react";
import { ContinueButtons } from "./ContinueButtons";
import { ComposeStepProps } from "./IComposeStep";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { Utility } from "../../../../utils";

type OwnProps = ComposeStepProps & {
};

type OwnState = ComposeStepState & {
};

export class DetailsForm extends ComponentWithValidatedForm<OwnProps, OwnState> implements IComposeStep {

    private _isMounted = false;

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.Abstract.ComposeDetails();
        this.state = {
            ...this.getInitialState(formModel),
            isSubmitLater: false,
        };
    }

    public componentDidMount() {
        this._isMounted = true;
        if (this.props.abstract)
            this.setFormData(this.props.abstract);

        this.initialChecks();

        if (this.props.type && this.props.abstract)
            this.setFormBuilderData(this.props.type, this.props.abstract);
    }

    public componentDidUpdate(prevProps: Readonly<OwnProps>, prevState: Readonly<OwnState>) {
        this.initialChecks(prevProps);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public setFormData(abstract: M.Abstract.Abstract) {
        const formModel = this.getFormModel() as Forms.Abstract.ComposeDetails;
        formModel.data.classificationId = abstract.classificationId || null;

        this.setState({
            ...this.state,
            formModel,
        });
    }

    public setFormBuilderData(type: M.Abstract.AbstractType, abstract: M.Abstract.Abstract) {
        if (type.form) {
            const formModel = this.getFormModel() as Forms.Abstract.ComposeDetails;
            formModel.data.classificationId = abstract.classificationId || null;
            formModel.data.classifications = type.classifications.length;
            M.FormBuilder.FormSubmissionHelper.setFormData(formModel.data, type.form, abstract.details);

            // make sure the chosen classification ID is valid for the abstract type.
            // if not, set value to null.
            if (type.classifications.map((x) => x.id).indexOf(formModel.data.classificationId || 0) === -1)
                formModel.data.classificationId = null;

            this.updateFormModel(formModel);
        }
    }

    public render() {
        const formModel = this.getFormModel() as Forms.Abstract.ComposeDetails;
        const fieldSections = formModel.data.sections.map((s, i) => <Comp.FormBuilder.FieldSection
                formComponent={this}
                key={i}
                section={s}
            />);

        const classifications: M.Editors.SelectItem[] = this.props.type
            ? this.props.type.classifications.map((x) => ({
                id: x.id,
                render: x.name,
            }))
            : [];

        const classificationField = classifications.length
            ? <Comp.Editors.DropdownField formComponent={this} name="classificationId" items={classifications} placeholder="Select..." required />
            : null;

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onCustomValidation={() => this.handleFormBuilderValidation()}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            schema={this.state.formModel.rules}
            ref={(ref: any) => this.form = ref}
        >
            <h1>Details</h1>

            {classificationField}

            {fieldSections}

            <ContinueButtons
                onBack={() => this.props.onBack()}
                onSave={(isSubmitLater) => this.onSaveHandler(isSubmitLater)}
                onSkip={() => this.props.onSkip()}
                processing={this.state.formProcessing}
            />

        </Comp.Validation.ValidatedForm>;
    }

    private initialChecks(prevProps?: Readonly<OwnProps>) {
        if (prevProps) {
            if ((!is(prevProps.type, this.props.type) || !is(prevProps.abstract, this.props.abstract)) && this.props.type && this.props.abstract) {
                // both abstract and type are available, update the form
                this.setFormBuilderData(this.props.type, this.props.abstract);
            }

            // if no form for this type, skip to next step
            if (!is(prevProps.type, this.props.type) && this.props.type && Utility.isNullOrUndefined(this.props.type.form)) {
                console.info(`No form for type ${this.props.type.name}. Skipping to uploads.`);
                this.props.onSkip();
            }
        }
        else {
            // if no form for this type, skip to next step
            if (this.props.type && Utility.isNullOrUndefined(this.props.type.form)) {
                console.info(`No form for type ${this.props.type.name}. Skipping to uploads.`);
                this.props.onSkip();
            }
        }
    }

    private onSaveHandler(isSubmitLater: boolean) {
        this.setState({ ...this.state, isSubmitLater }, () => {
            this.triggerSubmit();
        });
    }

    private handleFormBuilderValidation() {
        if (this.props.type && this.props.type.form)
            return M.FormBuilder.FormSubmissionHelper.validateSubmission(this, this.props.type.form, this.state.formModel.data);
        return [];
    }

    private handleSubmit(model: Forms.Abstract.ComposeDetailsData) {
        const body = {
            ...M.FormBuilder.FormSubmissionHelper.getPostBody(model),
            classificationId: model.classificationId,
            guid: this.props.abstract ? this.props.abstract.guid : undefined,
        };

        console.log(body);

        this.saveAbstract(model, body);
    }

    private async saveAbstract(model: Forms.Abstract.ComposeDetailsData, body: any) {
        this.toggleProcessing(true);

        const result = await this.props.api.post(Api.endpoints.abstract.composeDetails, {
            body: JSON.stringify(body),
        });

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            this.props.onAbstractSaved(result.data, this.state.isSubmitLater);
        }
        else {
            this.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
            this.toggleProcessing(false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/abstracts/composer/components/DetailsForm.tsx